export interface PhoneCountry {
    name: string
    iso2: string
    dialCode: string
}

export function flagEmoji(iso2: string): string {
    return iso2.toUpperCase().replace(/./g, (c) => String.fromCodePoint(c.charCodeAt(0) + 0x1f1a5))
}
